import { useContext } from "react";
import { AppContext } from "../../store/AppScopeProvider";

export const useAppConfig = () => {
  const { appState } = useContext(AppContext);
  const appSettings = appState.appSettings ?? {};
  const regionSettings = appSettings.currency_lang_timezone ?? {};
  const currency = regionSettings.currency ?? {};
  const taxes = appSettings.taxing ?? {};
  return {
    taxTerm: taxes.tax_term || "VAT",
    taxIdTerm: taxes.tax_id_term || "Tax ID",
    currencyPrecision: currency.currency_precision ?? 2,
    currencySymbol: currency.symbol || "",
    currencySymbolPlacement: currency.symbol_placement || "prefix",
    showCurrency: currency.show_currency ?? false,
    tenantPreferredLanguages: regionSettings.languages || []
  };
};
